import VisitUsSection from '../Common/VisitUsSection';
import BookVisitSection from '../Common/BookVisitSection';
import DrAeshaProfile from './DrAeshaProfile';
import DrAeshaAreasOfFocus from './DrAeshaAreasOfFocus';
import DrAeshaApproachBanner from './DrAeshaApproachBanner';
import DrAeshaEducationSection from './DrAeshaEducationSection';
import DrAeshaLifeBeyondDentistry from './DrAeshaLifeBeyondDentistry';
import TestimonialsSection from '../Common/TestimonialSection';
import IntroSection from '../Common/IntroSection';

import React, { useEffect, useRef } from 'react';
import AnimatedSection from '../Common/AnimatedSection';

const DrAesha = () => {
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50">
      {/* Hero Section */}
    <AnimatedSection id="intro" delay={200}>
        <IntroSection 
            title={"MEET DR. AESHA THAKKAR"} 
            about={"Your trusted Pristine Smile dentist"}/>
    </AnimatedSection>

      {/* Main Content */}
      <main className="w-full">
        <AnimatedSection id="profile" delay={0}>
          <DrAeshaProfile />
        </AnimatedSection>

        <AnimatedSection id="areas-of-focus" delay={200} className="bg-white">
          <DrAeshaAreasOfFocus />
        </AnimatedSection>

        <AnimatedSection id="approach" delay={400}>
          <DrAeshaApproachBanner />
        </AnimatedSection>

        <AnimatedSection id="education" delay={600} className="bg-white">
          <DrAeshaEducationSection />
        </AnimatedSection>

        <AnimatedSection id="life-beyond" delay={800}>
          <DrAeshaLifeBeyondDentistry />
        </AnimatedSection>

        <AnimatedSection id="testimonials" delay={1000} className="bg-white">
          <TestimonialsSection />
        </AnimatedSection>

        <AnimatedSection id="visit" delay={1200}>
          <VisitUsSection />
        </AnimatedSection>

        <AnimatedSection id="book" delay={1400} className="bg-white">
          <BookVisitSection />
        </AnimatedSection>
      </main>
    </div>
  );
};

export default DrAesha;